import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import * as BootstrapModal from 'react-bootstrap/Modal';
import Button, { BUTTON_TYPES } from 'components/Button/Button';

export default class Modal extends PureComponent {
    static propTypes = {
        isVisible: PropTypes.bool.isRequired,
        isSubmitting: PropTypes.bool,
        onSubmit: PropTypes.func,
        onClose: PropTypes.func,
        title: PropTypes.string,
        children: PropTypes.element,
        isSubmitDisabled: PropTypes.bool,
        isCloseButton: PropTypes.bool,
        submitButtonType: PropTypes.string,
        submitButtonText: PropTypes.string,
        closeButtonType: PropTypes.string,
        closeButtonText: PropTypes.string,
        extraButton: PropTypes.shape({
            label: PropTypes.string,
            onClick: PropTypes.func
        }),
        dialogClassName: PropTypes.string
    }

    static defaultProps = {
        closeButtonType: BUTTON_TYPES.SQUARE_HOLLOW_GRAY,
        closeButtonText: 'Retour',
        submitButtonType: BUTTON_TYPES.SQUARE_SOLID_BRAND,
        submitButtonText: 'Accepter',
        onClose: () => {},
        isCloseButton: true
    }

    render() {
        const {
            dialogClassName, isVisible, onClose, title, children,
            extraButton, isCloseButton, onSubmit, isSubmitting,
            closeButtonText, closeButtonType, submitButtonType,
            isSubmitDisabled, submitButtonText
        } = this.props;
        const isFooter = extraButton || isCloseButton || onSubmit;

        return (
            <BootstrapModal
                dialogClassName={dialogClassName}
                show={isVisible}
                onHide={onClose}>
                {isVisible
                    ? <div>
                        {title
                            ? <BootstrapModal.Header>
                                <BootstrapModal.Title>
                                    {title}
                                </BootstrapModal.Title>
                            </BootstrapModal.Header>
                            : null
                        }

                        {children
                            ? <BootstrapModal.Body>
                                {children}
                            </BootstrapModal.Body>
                            : null
                        }

                        {isFooter
                            ? <BootstrapModal.Footer>
                                {extraButton
                                    ? <Button
                                        label={extraButton.label}
                                        type={BUTTON_TYPES.SQUARE_HOLLOW_ORANGE}
                                        disabled={isSubmitting}
                                        onClick={extraButton.onClick} />
                                    : null
                                }

                                {isCloseButton
                                    ? <Button
                                        label={closeButtonText}
                                        type={closeButtonType}
                                        disabled={isSubmitting}
                                        onClick={onClose} />
                                    : null
                                }

                                {onSubmit
                                    ? <Button
                                        label={submitButtonText}
                                        isLoading={isSubmitting}
                                        type={submitButtonType}
                                        disabled={isSubmitting || isSubmitDisabled}
                                        onClick={onSubmit} />
                                    : null
                                }
                            </BootstrapModal.Footer>
                            : null
                        }
                    </div>
                    : null
                }
            </BootstrapModal>
        );
    }
}
